import { PropsWithChildren } from 'react';

interface JourneyLayoutProps extends PropsWithChildren {
    className?: string;
}

export function JourneyLayout({
    children,
    className = '',
}: JourneyLayoutProps) {
    return <div className={`journey-layout ${className}`}>{children}</div>;
}
